<div nz-row>
  <div nz-col [nzSpan]="dynamicSpan">
    <div class="stats-toolbar">
         @if (newIncidentCount > 0) {
          <button
            nz-button
            nzType="default"
            class="blockDiv blockDivNew toolbar-btn"
            (click)="onClickNewBreakdowns()"
            nz-tooltip
            [nzTooltipTitle]="'New breakdowns: ' + newIncidentCount"
            nzTooltipPlacement="bottom">
            <nz-icon nzType="alert" nzTheme="outline"></nz-icon>
            <span class="toolbar-badge">{{ newIncidentCount }}</span>
          </button>
        }
        <!-- <div nz-col class="blockDiv" (click)="onClickAllBreakdowns()" [ngClass]="openIncidentCount > 3 ? 'blockDivAlert' : ''">
            <h2>OPEN</h2>
            <h1>{{ openIncidentCount }}</h1>
        </div> -->
         <button
            nz-button
            nzType="default"
            class="blockDiv toolbar-btn toolbar-btn-whatsapp"
          (click)="onClickOpenWhatsappMessages()"
            nz-tooltip
            [nzTooltipTitle]="'Open WhatsApp messages: ' + whatsappService.openMessageCount()"
            nzTooltipPlacement="bottom">
            <nz-icon nzType="whats-app" nzTheme="outline" />
            <span class="toolbar-badge">{{ whatsappService.openMessageCount() }}</span>
          </button>
        <!-- <div nz-col class="blockDiv">
            <h2>TOTAL TODAY</h2>
            <h1>{{ this.dashboardStats()?.totalBreakdownsToday }}</h1>
        </div> -->
        <!-- <div nz-col class="blockDiv">
            <h2>AVG TOTAL TIME</h2>
            <h1>N/A</h1>
        </div>
        <div nz-col class="blockDiv">
            <h2>AVG OPERATIONAL TIME</h2>
            <h1>N/A</h1>
        </div>
        <div nz-col class="blockDiv">
            <h2>AVG TRAVEL TIME</h2>
            <h1>N/A</h1>
        </div> -->
        <!-- <div nz-col class="blockDiv">
            <h2>CANCELLED TODAY</h2>
            <h1>{{ this.dashboardStats()?.totalCancelledIncidentsToday }}</h1>
        </div>
    </div>-->
      @if (authService.hasClaims(['BDT'])) {
        <button
            nz-button
            nzType="default"
            class="blockDiv toolbar-btn"
            (click)="openTechniciansModal()"
            nz-tooltip
            [nzTooltipTitle]="techTooltip">
            <nz-icon nzType="tool" nzTheme="outline"></nz-icon>
          </button>
    }
    </div>
  </div> 
</div>

<ng-template #techTooltip>
  <div>Technicians Status:</div>
  <div>Ready: {{ getBreakdownTechnicianCountPerStatus(1) }}</div>
  <div>Unavailable: {{ getBreakdownTechnicianCountPerStatus(2) }}</div>
  <div>On breakdown: {{ getBreakdownTechnicianCountPerStatus(3) }}</div>
  <div>Unknown: {{ getBreakdownTechnicianCountPerStatus(null) }}</div>
</ng-template>


<nz-modal [(nzVisible)]="isTechniciansModalVisible" 
          nzTitle="Technicians" 
          [nzFooter]="null" 
          (nzOnCancel)="closeTechniciansModal()"
          nzWidth="95%">
  <ng-container *nzModalContent>
    <div>
      <nz-collapse  style="margin-bottom: 16px;">
      <nz-collapse-panel 
        [(nzActive)]="isAddTechnicianPanelOpen"
        nzHeader="Add New Technician"
        [nzShowArrow]="true">
        <form nz-form (ngSubmit)="addTechnician()" #addTechnicianForm="ngForm">
          <div nz-row nzGutter="16" >
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label nzRequired>First Name</nz-form-label>
                <nz-form-control>
                  <input nz-input name="firstName" [(ngModel)]="newTechnician.firstName" required />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label nzRequired>Phone Number</nz-form-label>
                <nz-form-control>
                  <input nz-input name="phoneNumber" [(ngModel)]="newTechnician.userCell" required />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          
          <div nz-row nzGutter="16">
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label nzRequired>Last Name</nz-form-label>
                <nz-form-control>
                  <input nz-input name="lastName" [(ngModel)]="newTechnician.lastName" required />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
              <nz-form-item>
                <nz-form-label nzRequired>Email</nz-form-label>
                <nz-form-control>
                  <input nz-input name="email" [(ngModel)]="newTechnician.userEmail" required />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
          
          <div style="text-align: right; margin-top: 20px;">
            <button nz-button nzType="default" (click)="isAddTechnicianPanelOpen = false" style="margin-right: 8px;">
              Cancel
            </button>
            <button nz-button nzType="primary" [disabled]="!addTechnicianForm.form.valid" htmlType="submit">
              Add Technician
            </button>
          </div>
        </form>
      </nz-collapse-panel>
    </nz-collapse>
    </div>
    <nz-table #techniciansTable [nzData]="sharedDataService.breakdownTechnicians" [nzPageSize]="10">
      <thead>
        <tr>
          <th>Name</th>
          <th>Tel</th>
          <th>Status</th>
          <th>Last Updated</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let technician of techniciansTable.data">
          <td>{{ technician.name }}</td>
          <td>{{ technician.phoneNumber }}</td>
          <td>
            @if (technician.statusId === 1) {
              <nz-tag nzColor="success">READY</nz-tag>
            } @else if (technician.statusId === 2) {
              <nz-tag nzColor="default">UNAVAILABLE</nz-tag>
            } @else if (technician.statusId === 3) {
              <nz-tag nzColor="processing">ON BREAKDOWN</nz-tag>
            } @else {
              <nz-tag nzColor="warning">UNKNOWN</nz-tag>
            }
          </td>
          <td>{{ technician.dtLogged + 'Z' | date: 'MMM d, y h:mm a' }}</td>
          <td>
            <nz-radio-group [(ngModel)]="technician.statusId" (ngModelChange)="updateTechnicianStatus(technician, $event)" nzSize="small">
              <label nz-radio-button [nzValue]="1">
                <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                Ready
              </label>
              <label nz-radio-button [nzValue]="2">
                <span nz-icon nzType="close-circle" nzTheme="outline"></span>
                Unavailable
              </label>
              <label nz-radio-button [nzValue]="3">
                <span nz-icon nzType="tool" nzTheme="outline"></span>
                On Breakdown
              </label>
            </nz-radio-group>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>
